module.exports = __webpack_public_path__ + "static/media/akanksha_mahajan.d481332f.png";